import { ChipColors, ChipSizes, ChipVariant } from '@/constants/chipTypes';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ChipProps {
  label: string;
  variant: ChipVariant;
  size: ChipSizes;
  color: ChipColors;
}

export const InertChip = ({ label, size, color, variant }: ChipProps) => {
  return (
    <StyledChip
      label={label}
      size={size}
      color={color}
      variant={variant}
    />
  );
};

const StyledChip = styled(Chip)({
  '& .MuiChip-label': {
    color: '#fff',
  },
});
